<!-- Main template -->
@if (configuration.display) { @if (!isLoading) {
<div class="list-details-container" [class.is-header-fixed]="isFixed">
    <!-- Sticky header -->
    <div class="list-details-header">
        <ul class="single-line" #listDetailsScrollable>
            @for (container of containers; track container; let i = $index) {
            @switch (container.type) { @case ('downloads') { @if
            (container.config?.flyer?.show || (container.config?.files?.show &&
            data?.files && data.files.length > 0)) {
            <li
                class="is-font-sm is-color-primary-on-active is-border-color-primary-on-active"
                [class.active]="i === containerActive"
                (click)="onContainerNavigate(i, container.key)"
            >
                {{ container.label }}
            </li>
            } } @default {
            <li
                class="is-font-sm is-color-primary-on-active is-border-color-primary-on-active"
                [class.active]="i === containerActive"
                (click)="onContainerNavigate(i, container.key)"
            >
                {{ container.label }}
            </li>
            } } }
        </ul>
    </div>
    <!-- Detailed items -->
    <div class="list-details-content">
        @for (container of containers; track container) { @switch
        (container.type) { @case ('downloads') { @if
        (container.config?.flyer?.show || (container.config?.files?.show &&
        data?.files && data.files.length > 0)) {
        <div [id]="container.key" class="list-details-container">
            <h2 class="is-font-h2 is-font-bold mt-0">{{ container.label }}</h2>
            @if (container.config?.flyer?.show) {
            <button
                class="ras-btn-link ras-download-flyer is-color-primary"
                rasProposal
                [branchPhone]="data?.branch_phone"
                [equipmentId]="data?.equipment_number"
            >
                @if (container.config?.flyer?.icon) {
                <fa-icon
                    [icon]="['far', container.config.flyer.icon]"
                ></fa-icon>
                }
                {{ container.config?.flyer?.label }}
            </button>
            } @if (container.config?.files?.show && data?.files &&
            data.files.length > 0) {
            <div>
                @for (file of data.files; track file) {
                <div class="download-link-container">
                    <a
                        class="ras-download-flyer is-color-primary"
                        target="_blank"
                        [href]="file.url"
                    >
                        @if (file.type !== 'pdf') {
                        <fa-icon [icon]="['far', 'file']"></fa-icon>
                        } @if (file.type === 'pdf') {
                        <fa-icon [icon]="['far', 'file-pdf']"></fa-icon>
                        }
                        {{ file.name }}
                    </a>
                </div>
                }
            </div>
            }
        </div>
        } } @case ('modal-link') {
        <div [id]="container.key" class="list-details-container">
            <h2 class="is-font-h2 is-font-bold mt-0">{{ container.label }}</h2>
            <ras-modal-link [configuration]="container.config"></ras-modal-link>
        </div>
        } @default {
        <div
            class="list-details-container"
            ras-list-details-item
            [id]="container.key"
            [data]="container"
        ></div>
        } } }
    </div>
</div>
} @else {
<div class="list-details-container is-loading">
    <div class="list-details-header">
        <ul class="single-line">
            <li></li>
            <li></li>
            <li></li>
        </ul>
    </div>
    <div class="list-details-content">
        <div class="list-details-container">
            <p class="mt-0"></p>
            <div></div>
        </div>
    </div>
</div>
}
<!-- Loading template -->
}
